let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    memoryTimer = null,
    originalCards = [],
    changedCardIndex = -1,
    changedCardOriginalImage = '',
    changedCardNewImage = '';

class ReverseMemoGame {
    constructor() {
        this.memoryPhase = document.querySelector('[data-phase="memory"]');
        this.findPhase = document.querySelector('[data-phase="find"]');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerElement = document.querySelector('[data-timer]');
        this.findGrid = document.querySelector('[data-find-grid]');

        // Pobierz dane z window
        if (window.reverseMemoData) {
            gameData = window.reverseMemoData;
            originalCards = [...gameData.cards];
        }

        this.init();
    }

    init() {
        this.startMemoryPhase();
    }

    startMemoryPhase() {
        let timeLeft = gameData.memoryTime;

        // Odtwórz dźwięk startu
        if (audio && audio.start) {
            audio.start.play();
            stopAudioAfterDelay(audio.start, 2000);
        }

        memoryTimer = setInterval(() => {
            timeLeft--;

            if (this.timerElement) {
                this.timerElement.textContent = timeLeft;

                // Animacja ostatnich 3 sekund
                if (timeLeft <= 3) {
                    this.timerElement.classList.add('timer-warning');
                    if (audio && audio.drag) {
                        audio.drag.play();
                    }
                }
            }

            if (timeLeft <= 0) {
                clearInterval(memoryTimer);
                this.switchToFindPhase();
            }
        }, 1000);
    }

    switchToFindPhase() {
        // Ukryj fazę zapamiętywania
        if (this.memoryPhase) {
            this.memoryPhase.classList.add('hidden');
        }

        // Przygotuj zmienione karty
        this.prepareChangedCards();

        // Pokaż fazę szukania
        if (this.findPhase) {
            this.findPhase.classList.remove('hidden');
        }

        // Dźwięk przejścia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 2000);
        }
    }

    prepareChangedCards() {
        // Skopiuj oryginalne karty
        const modifiedCards = [...originalCards];

        // Znajdź wszystkie unikalne pair_id
        const uniquePairs = [...new Set(modifiedCards.map(c => c.pair_id))];

        // Wybierz losową parę do zmiany
        const pairToChange = uniquePairs[Math.floor(Math.random() * uniquePairs.length)];

        // Znajdź kartę do zmiany (pierwszą z tej pary)
        changedCardIndex = modifiedCards.findIndex(c => c.pair_id === pairToChange);

        if (changedCardIndex === -1) return;

        // Zapisz oryginalny obrazek
        changedCardOriginalImage = modifiedCards[changedCardIndex].image;

        // Znajdź inny obrazek (z innej pary)
        const otherPairs = gameData.allPairs.filter((pair, index) => index !== pairToChange);
        if (otherPairs.length > 0) {
            const randomOtherPair = otherPairs[Math.floor(Math.random() * otherPairs.length)];
            changedCardNewImage = randomOtherPair.card_image;

            // Zmień obrazek
            modifiedCards[changedCardIndex].image = changedCardNewImage;
            modifiedCards[changedCardIndex].changed = true;
        }

        // Renderuj karty w fazie find
        this.renderFindCards(modifiedCards);
    }

    renderFindCards(cards) {
        if (!this.findGrid) return;

        this.findGrid.innerHTML = '';

        cards.forEach((card, index) => {
            const cardEl = document.createElement('div');
            cardEl.className = 'reverse-memo-card find-phase';
            cardEl.dataset.cardIndex = index;
            cardEl.dataset.isChanged = card.changed ? 'true' : 'false';

            cardEl.innerHTML = '<div class="card-inner">' +
                '<div class="card-back" style="background-color: ' + gameData.cardBackColor + ';"></div>' +
                '<div class="card-front">' +
                '<img src="' + card.image + '" alt="' + (card.name || '') + '">' +
                '</div>' +
                '</div>';

            // Event listener
            cardEl.addEventListener('click', () => this.handleCardClick(cardEl, card, index));

            this.findGrid.appendChild(cardEl);
        });

        // Animacja pojawienia się kart
        setTimeout(() => {
            const allCards = this.findGrid.querySelectorAll('.reverse-memo-card');
            allCards.forEach((card, i) => {
                setTimeout(() => {
                    card.classList.add('revealed');
                }, i * 100);
            });
        }, 300);
    }

    handleCardClick(cardEl, card, index) {
        // Sprawdź czy karta już została kliknięta
        if (cardEl.classList.contains('clicked')) {
            return;
        }

        // Odwróć kartę
        cardEl.classList.add('flipped');

        // Dźwięk kliknięcia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 500);
        }

        setTimeout(() => {
            cardEl.classList.add('clicked');

            // Sprawdź czy to zmieniona karta
            if (index === changedCardIndex) {
                this.handleCorrectAnswer(cardEl);
            } else {
                this.handleWrongAnswer(cardEl);
            }
        }, 600);
    }

    handleCorrectAnswer(cardEl) {
        // Animacja sukcesu
        cardEl.classList.add('correct');

        // Dźwięk sukcesu
        if (audio && audio.valid) {
            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 2000);
        }

        // Flash zielony
        gameFrame.style.borderColor = 'green';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Pokaż wynik po chwili
        setTimeout(() => {
            this.showResult(true);
        }, 1500);
    }

    handleWrongAnswer(cardEl) {
        // Animacja błędu
        cardEl.classList.add('incorrect');

        // Dźwięk błędu
        if (audio && audio.wrong) {
            audio.wrong.play();
            stopAudioAfterDelay(audio.wrong, 1000);
        }

        // Flash czerwony
        gameFrame.style.borderColor = 'red';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Odwróć kartę z powrotem po chwili
        setTimeout(() => {
            cardEl.classList.remove('flipped', 'clicked', 'incorrect');
        }, 1000);
    }

    showResult(success) {
        // Ukryj fazę szukania
        if (this.findPhase) {
            this.findPhase.classList.add('hidden');
        }

        // Pokaż fazę wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        // Ustaw treść wyniku
        const resultIcon = this.resultPhase.querySelector('[data-result-icon]');
        const resultTitle = this.resultPhase.querySelector('[data-result-title]');
        const resultMessage = this.resultPhase.querySelector('[data-result-message]');
        const originalCardEl = this.resultPhase.querySelector('[data-original-card]');
        const changedCardEl = this.resultPhase.querySelector('[data-changed-card]');

        if (success) {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-check-circle"></i>';
                resultIcon.className = 'result-icon success';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Brawo! Znalazłeś zmienioną kartę!';
                resultTitle.className = 'result-title success';
            }
            if (resultMessage) {
                resultMessage.textContent = 'Świetnie zapamiętałeś oryginalne pary i zauważyłeś różnicę!';
            }

            // Dźwięk sukcesu
            if (audio && audio.success) {
                audio.success.play();
                stopAudioAfterDelay(audio.success, 3000);
            }
        }

        // Pokaż porównanie kart
        if (originalCardEl) {
            originalCardEl.innerHTML = '<img src="' + changedCardOriginalImage + '" alt="Oryginalna karta">';
        }
        if (changedCardEl) {
            changedCardEl.innerHTML = '<img src="' + changedCardNewImage + '" alt="Zmieniona karta">';
        }
    }

    restart() {
        // Reset zmiennych
        changedCardIndex = -1;
        changedCardOriginalImage = '';
        changedCardNewImage = '';

        // Zatrzymaj timer
        if (memoryTimer) {
            clearInterval(memoryTimer);
        }

        // Reset timera
        if (this.timerElement) {
            this.timerElement.textContent = gameData.memoryTime;
            this.timerElement.classList.remove('timer-warning');
        }

        // Reset faz
        if (this.memoryPhase) {
            this.memoryPhase.classList.remove('hidden');
        }
        if (this.findPhase) {
            this.findPhase.classList.add('hidden');
        }
        if (this.resultPhase) {
            this.resultPhase.classList.add('hidden');
        }

        // Wyczyść grid
        if (this.findGrid) {
            this.findGrid.innerHTML = '';
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';

        // Rozpocznij od nowa
        this.startMemoryPhase();
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--reverse-memo');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new ReverseMemoGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            if (memoryTimer) {
                clearInterval(memoryTimer);
            }
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-reverse-memo.js